import { DatePicker, Layout, Tooltip } from "antd";
import FormItem from "antd/lib/form/FormItem";
import React, { createContext, useContext } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { EbendoDailyProductionForm } from "./EbendoDailyProductionForm";

import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";

import { observer } from "mobx-react-lite";
import moment from "moment";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
import { CommandBar } from "@fluentui/react";
import { X } from "react-feather";
const { Content } = Layout;
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const initData = {
  aseRiverExport: 0,
  aseRiverUptime: 0,
  bsw: 0,
  crudeInjectionGGF: 0,
  ebendoDailyProductionId: 0,
  flareGas: 0,
  forcadosExport: 0,
  forcadosUptime: 0,
  fuelGas: 0,
  gas: 0,
  condensate: 0,
  gasSuppliedToGasPlant: 0,
  netProduction: 0,
  oil: 0,
  blpd: 0,
  productionDate: moment(new Date())._d,
  stationDownHrs: 0,
  water: 0,
  stationAPI: 0,
  remarks: "",
};
export const EbendoManualFormEntry = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  return (
    <Layout
      style={{
        background: "#fff",
        marginTop: "20px",
      }}
    >
      <Content
        className="ms-depth8"
        style={{
          background: "#F0F2F5",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <SubPageHeaderTitle title="Ebendo Daily Field Production Entry  Pane" />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <CommandBar
              items={[
                {
                  key: "clear",
                  text: "Clear Entries",
                  onRenderIcon: () => <X />,
                  onClick: async () => {
                    ebendoDailyProductionStore.initFormaData = initData;
                    ebendoDailyProductionStore.uploadDate = moment(new Date());
                    ebendoDailyProductionStore.wellparameters.clear();
                    await ebendoDailyProductionStore.loadInitialWellParameters();
                    ebendoDailyProductionStore.showNaocDailyProductionDialog = true;
                  },
                },
              ]}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <FormItem
              label={
                <span style={{ color: "red" }}>Production Refer Date *</span>
              }
            >
              <Tooltip title="Ebendo field production date">
                <DatePicker
                  value={toAntPickerDate(ebendoDailyProductionStore?.uploadDate)}
                  onChange={(date, dateString) => {
                    console.log(date, dateString);
                    ebendoDailyProductionStore.uploadDate = dateString;
                    ebendoDailyProductionStore.initFormaData.productionDate =
                      getPickerDate(date);
                  }}
                  style={{ width: "100%" }}
                  defaultValue={toAntPickerDate(new Date())}
                  format={"DD-MMM-YYYY"}
                />
              </Tooltip>
            </FormItem>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <EbendoDailyProductionForm />
          </div>
        </div>
      </Content>
    </Layout>
  );
});

